import { render, staticRenderFns } from "./MagicLinkReport.vue?vue&type=template&id=482102ee&scoped=true&"
import script from "./MagicLinkReport.vue?vue&type=script&lang=js&"
export * from "./MagicLinkReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482102ee",
  null
  
)

export default component.exports